import { useRef } from 'react';
import { Box } from '@mui/material';

type FileUploaderProps = {
  accept?: string;
  children: React.ReactNode;
  validate: (file: File) => Promise<void>;
};

export const FileUploader = ({
  accept = '*/*',
  children,
  validate,
}: FileUploaderProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const onSelectFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    await validate(file);
  };

  const handleClick = () => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  return (
    <Box
      onClick={handleClick}
      sx={{
        cursor: 'pointer',
        display: 'flex',
        width: '100%',
      }}
    >
      {children}
      <Box
        accept={accept}
        component="input"
        hidden
        onChange={onSelectFile}
        ref={inputRef}
        type="file"
      />
    </Box>
  );
};
